import ReservationsModule, {
  ReservationsModuleProps,
} from './ReservationsModule';

export type {ReservationsModuleProps};
export default ReservationsModule;
